// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aUi8","rootNoMargin":"styles_rootNoMargin__Vmlqy"};